
import React from 'react';

const TableSortDropdown = ({ handleTableSort, fieldName, onOpenPropertySettingsModal,
    showPropertySettings = false
}) => {

    return (
        <div className="w-60 bg-white border shadow-md rounded-md text-sm p-1">
            {showPropertySettings && (
                <div
                    className="px-1 py-1 hover:bg-gray-100 cursor-pointer font-semibold flex items-center space-x-2"
                    onClick={(e) => onOpenPropertySettingsModal(fieldName, e)}
                >
                    <svg
                        className="text-black"
                        style={{ width: '21px', height: '20px' }}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.591 1.01c1.543-.942 3.31.825 2.368 2.368a1.724 1.724 0 001.01 2.592c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.01 2.591c.942 1.543-.825 3.31-2.368 2.368a1.724 1.724 0 00-2.591 1.01c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.592-1.01c-1.543.942-3.31-.825-2.368-2.368a1.724 1.724 0 00-1.01-2.591c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.01-2.592c-.942-1.543.825-3.31 2.368-2.368a1.724 1.724 0 002.592-1.01z"
                        />
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                    </svg>
                    <span
                        className="text-xs font-bold"
                        style={{
                            fontSize: '12px',
                            textTransform: 'capitalize',
                            fontWeight: 500,
                            color: 'black',
                            fontFamily: 'sans-serif',
                        }}
                    >
                        Property Settings
                    </span>
                </div>
            )}

            <div
                className="px-1 py-1 hover:bg-gray-100 cursor-pointer font-semibold flex items-center space-x-2"
                onClick={() => handleTableSort(fieldName, 'ASC')}
            >
                <svg
                    className="text-black"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    style={{ width: '21px', height: '20px' }}
                >
                    <path
                        fillRule="evenodd"
                        d="M10 3a1 1 0 01.707.293l4 4a1 1 0 11-1.414 1.414L11 6.414V17a1 1 0 11-2 0V6.414L6.707 8.707a1 1 0 11-1.414-1.414l4-4A1 1 0 0110 3z"
                        clipRule="evenodd"
                    />
                </svg>
                <span
                    className="text-xs font-bold"
                    style={{
                        fontSize: '12px',
                        textTransform: 'capitalize',
                        fontWeight: 500,
                        color: 'black',
                        fontFamily: 'sans-serif',
                    }}
                >
                    Sort ascending
                </span>
            </div>
            <div
                className="px-1 py-1 hover:bg-gray-100 cursor-pointer font-semibold flex items-center space-x-2"
                onClick={() => handleTableSort(fieldName, 'DESC')}
            >
                <svg
                    className="text-black"
                    style={{ width: '21px', height: '20px' }}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        fillRule="evenodd"
                        d="M10 17a1 1 0 01-.707-.293l-4-4a1 1 0 111.414-1.414L9 13.586V3a1 1 0 112 0v10.586l2.293-2.293a1 1 0 111.414 1.414l-4 4A1 1 0 0110 17z"
                        clipRule="evenodd"
                    />
                </svg>

                <span
                    className="text-xs font-bold"
                    style={{
                        fontSize: '12px',
                        textTransform: 'capitalize',
                        fontWeight: 500,
                        color: 'black',
                        fontFamily: 'sans-serif',
                    }}
                >
                    Sort descending
                </span>
            </div>

        </div>
    );
};

export default TableSortDropdown;
